(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12730],{

/***/ 12730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8872);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var TopProgressBar = function(param) {
    var elementRef = param.elementRef;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), progress = ref[0], setProgress = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleOnScroll = function() {
            if (elementRef && elementRef.current) {
                var innerHeight = window.innerHeight;
                var ref = elementRef.current.getBoundingClientRect(), top = ref.top, height = ref.height;
                var position = top * -1 / ((height - innerHeight) / 100);
                position < 100 && position > 0 ? setProgress(position) : setProgress(0);
            }
        };
        handleOnScroll();
        window.addEventListener("scroll", handleOnScroll);
        return function() {
            return window.removeEventListener("scroll", handleOnScroll);
        };
    }, [
        elementRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().topProgressBar),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().progress),
            style: {
                width: "".concat(progress, "%")
            }
        })
    });
};
TopProgressBar.propTypes = {
    elementRef: prop_types__WEBPACK_IMPORTED_MODULE_3___default().instanceOf(Object).isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (TopProgressBar);


/***/ }),

/***/ 8872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topProgressBar":"styles_topProgressBar__UwaF5","progress":"styles_progress___tNBz"};

/***/ })

}]);